import utils from 'utils'
class invoiceGatherListCtrl {
  constructor(
    $scope,
    sweetalert,
    $state,
    httpRequest,
    logger,
    $uibModal,
    $timeout,
    initSortService,
    Upload,
    $rootScope,
    getOvatAmtService
  ) {
    $scope.queryParam = {
      pageNum: 1,
      pageSize: 10,
      param: {
        checkStatus: '', //勾选状态
        invoiceType: '', // 发票类型,
        periodCode: '', // 所属期,
        voucherCode: '',
        accountStatus: '',
      },
    }
    $scope.isCollapsed = false
    $scope.taxPeriod = { value: '' }
    $scope.currentTaxPeriod = ''
    $scope.isCurrentPeriod = true //是否是当前暑期
    $scope.totalItem = 0
    $scope.dicData = {}
    $scope.voucherModel = '' // 对账模式
    // 选中合同信息
    $scope.selectedRows = []
    $scope.invoiceStatistical = {}
    $scope.copyInvoiceStatistical = {}
    $scope.expireTime = ''

    $scope.queryList = function queryList(init) {
      $scope.queryParam = sessionStorage.invoiceGatherParam
        ? JSON.parse(sessionStorage.invoiceGatherParam)
        : $scope.queryParam
      if (init) {
        $scope.queryParam.pageNum = 1
        $scope.reset()
        $scope.searchList()
        return
      }
      $scope.queryParam.param.periodCode = $scope.taxPeriod.value.replace(
        /-/g,
        ''
      )
      httpRequest
        .post_qryVoucherInvoicePageList($scope.queryParam)
        .then((res) => {
          let result = res.data.value.list
          result.forEach((item) => {
            item._statusColor =
              item.accountStatus == 1
                ? '#32B0B7'
                : item.accountStatus == 2
                ? '#EA0000'
                : '#C515AF'
          })
          $scope.gatherList = result

          $scope.totalItem = res.data.value.total
          $scope.queryParam.pageNum = res.data.value.pageNum
          $scope.selectedRows = []
        })
      getStatistics()
    }

    $scope.searchList = function () {
      sessionStorage.setItem(
        'invoiceGatherParam',
        JSON.stringify($scope.queryParam)
      )
      $scope.queryList()
    }
    // 分页
    $scope.pageChanged = function () {
      // 点击页码发起查询
      sessionStorage.setItem(
        'invoiceGatherParam',
        JSON.stringify({
          pageNum: $scope.queryParam.pageNum,
          pageSize: $scope.queryParam.pageSize,
          param: sessionStorage.invoiceGatherParam
            ? JSON.parse(sessionStorage.invoiceGatherParam).param
            : {
                checkStatus: '', //勾选状态
                invoiceType: '', // 发票类型,
                periodCode: '', // 所属期,
                voucherCode: '',
                accountStatus: '',
              },
        })
      )
      $scope.queryList()
    }
    //是否是当前属期
    function getIsCurrentPeriod(periodCode, expireTime) {
      if (!periodCode || !expireTime) return false
      let currentTime = getCurrentDate()
      if (currentTime < expireTime) {
        if (
          periodCode.slice(0, 6) <= currentTime.slice(0, 6) &&
          currentTime.slice(0, 6) <= expireTime.slice(0, 6)
        ) {
          return true
        }
      }
      return false
    }
    //获取属期
    async function getPeriod() {
      let res = await httpRequest.get_qryOrgTaxPeriod(
        JSON.parse(localStorage.user_info).user.currentOrgId
      )
      let periodCode = res.data.value.periodCode
      $scope.expireTime =
        res.data.value.expireTime && res.data.value.expireTime.replace(/-/g, '')
      if (periodCode) {
        $scope.taxPeriod.value =
          periodCode.slice(0, 4) + '-' + periodCode.slice(4)
        $scope.isCurrentPeriod = getIsCurrentPeriod(
          periodCode,
          $scope.expireTime
        )
        $scope.queryParam.param.periodCode = periodCode
        $scope.currentTaxPeriod = periodCode
        $scope.queryList(true)
        await $timeout(() => {
          $('#taxPeriod').datetimepicker({
            startView: 3,
            autoclose: true,
            minView: 'year',
            language: 'zh-CN',
            format: 'yyyymm',
            forceParse: 0,
            pickTime: false,
            pickerPosition: 'bottom-right',
            endDate: $scope.taxPeriod.value,
            initialDate: $scope.taxPeriod.value,
          })
        })
        $scope.taxPeriod.value = $scope.taxPeriod.value.replace(/-/g, '')
        // 改变税款所属期
        $scope.$watch('taxPeriod.value', (newVal, oldVal) => {
          if (newVal && newVal !== oldVal) {
            $scope.isCurrentPeriod = getIsCurrentPeriod(
              newVal,
              $scope.expireTime
            )
            $scope.reset()
            $scope.queryParam.pageNum = 1
            $scope.totalItem = 0
            $scope.searchList()
          }
        })
      }
    }
    //获取数据统计
    function getStatistics() {
      httpRequest
        .post_voucherInvoiceStatistical($scope.queryParam)
        .then((res) => {
          let result = res.data.value
          if (!result) return
          $scope.invoiceStatistical.totalTaxamt = fixNumber(result.totalTaxamt)
          $scope.invoiceStatistical.totalAmt = fixNumber(result.totalAmt)
          $scope.invoiceStatistical.invoiceNum = result.invoiceNum
          $scope.copyInvoiceStatistical = JSON.parse(
            JSON.stringify($scope.invoiceStatistical)
          )
        })
    }
    //获取对账模式
    function getModalData() {
      httpRequest.get_SysParamMap().then((res) => {
        let ivat = res.data.value.ivat
        ivat.forEach((item) => {
          if (item.paramCode == 'ivat_voucher_account_setting') {
            let val = item.paramValue.split(',')[1]
            $scope.voucherModel = val
          }
        })
      })
    }
    $scope.reset = function reset() {
      $scope.queryParam.param = {
        checkStatus: '',
        invoiceType: '',
        periodCode: '',
        voucherCode: '',
        accountStatus: '',
      }
    }
    $scope.link = function (item) {
      if (!$scope.isCurrentPeriod) return
      if ($scope.voucherModel != 1) {
        return logger.logTips('不可操作，只可在凭证号比对模式下使用', 'warn')
      }
      const selectedRows = item || $scope.selectedRows
      if (!selectedRows.length) {
        return logger.logError('请选择要关联的数据行')
      }
      for (var i = 0; i < selectedRows.length; i++) {
        if (selectedRows[i].accountStatus == 1) {
          return logger.logError('已对账相符不允许关联其他凭证！')
        }
      }
      let isSingle = item ? true : false
      let invoiceTypeName = ''
      if (isSingle) {
        let list = $scope.dicData['ivat_voucher_inv_type']
        list.forEach((item) => {
          if (item.enumCode == selectedRows[0].invoiceType) {
            invoiceTypeName = item.enumName
          }
        })
      }
      $scope.linkHandle(selectedRows, isSingle, invoiceTypeName)
    }
    $scope.linkHandle = function (invoiceList, isSingle, invoiceTypeName) {
      $uibModal
        .open({
          templateUrl: 'invoiceLink.html',
          openedClass: 'mod-modal modal-edit-taxpayer-container',
          animation: true,
          controller: [
            '$scope',
            'obj',
            '$uibModalInstance',
            'httpRequest',
            function ($scope, obj, $uibModalInstance, httpRequest) {
              $scope.showSearch = false
              $scope.voucherCode = { value: '', id: '' }
              $scope.searchList = []
              $scope.invoiceList = obj.invoiceList
              $scope.isSingle = obj.isSingle
              $scope.totalTaxamt = '0.00'
              let timeout, showFlag
              $scope.cancel = function cancel() {
                $uibModalInstance.dismiss()
              }
              if (!obj.isSingle) {
                let totalTaxamt = 0
                obj.invoiceList.forEach((item) => {
                  totalTaxamt += item.totalTaxamt * 1
                })
                $scope.totalTaxamt = fixNumber(totalTaxamt)
              } else {
                $scope.invoiceTypeName = obj.invoiceTypeName
                let { voucherCode, voucherId } = $scope.invoiceList[0]
                if (voucherCode && voucherId) {
                  $scope.voucherCode = { value: voucherCode, id: voucherId }
                }
              }
              $scope.ok = function ok() {
                $uibModalInstance.close($scope.voucherCode)
              }
              $scope.$watch('voucherCode.value', (newVal, oldVal) => {
                if (newVal && newVal != oldVal && !showFlag) {
                  if (timeout) clearTimeout(timeout)
                  timeout = setTimeout(() => {
                    searchHandle(newVal)
                  }, 400)
                }
                if (!newVal) {
                  $scope.showSearch = false
                }
                showFlag = false
              })
              $scope.select = function (item) {
                if (item) {
                  $scope.voucherCode.value = item.voucherCode
                  $scope.voucherCode.id = item.voucherId
                  showFlag = true
                }
                $scope.showSearch = false
              }
              function searchHandle(val) {
                httpRequest
                  .get_queryVoucherCode({
                    taxPeriod: obj.taxPeriod.replace(/-/g, ''),
                    voucherCode: val,
                  })
                  .then((res) => {
                    if (
                      res.data.value &&
                      res.data.value.length &&
                      $scope.voucherCode.value
                    ) {
                      $scope.searchList = res.data.value
                      $scope.showSearch = true
                    } else {
                      $scope.showSearch = false
                    }
                  })
              }
            },
          ],
          resolve: {
            obj() {
              return {
                taxPeriod: $scope.taxPeriod.value,
                invoiceList,
                isSingle,
                invoiceTypeName,
              }
            },
          },
        })
        .result.then(
          (data) => {
            let taxPeriod = $scope.taxPeriod.value
            httpRequest
              .post_batchLinkVoucher({
                invoiceList: invoiceList,
                taxPeriod,
                voucherCode: data.value,
                voucherId: data.id,
              })
              .then((res) => {
                if (res.data.success) {
                  logger.logSuccess('关联成功！')
                } else {
                  logger.logError(res.data.message)
                }
                $scope.queryList()
              })
          },
          () => {}
        )
    }
    // 初始化查询和表格控件实例
    $scope.customizedConfig = {
      version: 1.0,
      table: [
        {
          label: '对账状态',
          selected: true,
          default: true,
        },
        {
          label: '凭证号',
          selected: true,
          default: true,
        },
        {
          label: '发票种类',
          selected: true,
          default: true,
        },
        {
          label: '发票代码',
          selected: true,
          default: true,
        },
        {
          label: '发票号码',
          selected: true,
          default: true,
        },
        {
          label: '开票日期',
          selected: true,
          default: true,
        },
        {
          label: '金额',
          selected: true,
          default: true,
        },
        {
          label: '税额',
          selected: true,
          default: true,
        },
        {
          label: '价税合计',
          selected: true,
          default: true,
        },
        {
          label: '销方名称',
          selected: true,
          default: true,
        },
        {
          label: '勾选状态',
          selected: true,
          default: true,
        },
        {
          label: '采集系统',
          selected: true,
          default: true,
        },
      ],
    }
    $scope.tableDropdownConfig = [
      {
        label: '不对帐',
        handler(item) {
          sweetalert
            .confirm('提醒', '确认不对账？确定后该数据不进入对账台账！')
            .then(() => {
              let param = {
                invoiceId: item.invoiceId,
                sources: item.invoiceSources,
                taxPeriod: $scope.currentTaxPeriod,
                optEnum: 2,
              }
              httpRequest.get_invoiceOpt(param).then(() => {
                logger.logSuccess('操作成功')
                $scope.queryList()
              })
            })
        },
        showWhile(item, hasPermit) {
          return (
            hasPermit('gather_account') &&
            item.accountStatus != -1 &&
            $scope.isCurrentPeriod
          )
        },
      },
      {
        label: '对帐',
        handler(item) {
          sweetalert
            .confirm(
              '提醒',
              '确定修改为对账数据？确定后该数据将进入对账台账，请重新对账！'
            )
            .then(() => {
              let param = {
                invoiceId: item.invoiceId,
                sources: item.invoiceSources,
                taxPeriod: $scope.currentTaxPeriod,
                optEnum: 1,
              }
              httpRequest.get_invoiceOpt(param).then(() => {
                logger.logSuccess('操作成功')
                $scope.queryList()
              })
            })
        },
        showWhile(item, hasPermit) {
          return (
            hasPermit('gather_account') &&
            item.accountStatus == -1 &&
            $scope.isCurrentPeriod
          )
        },
      },
      {
        label: '关联',
        handler(item) {
          $scope.link([item])
        },
        showWhile(item, hasPermit) {
          return (
            hasPermit('link_certificate') &&
            item.accountStatus != 1 &&
            $scope.isCurrentPeriod
          )
        },
      },
    ]
    function getCurrentDate() {
      let date = new Date()
      let fullYeamr = date.getFullYear()
      let month = date.getMonth() + 1
      month = month > 9 ? month : '0' + month
      let day = date.getDate()
      day = day > 9 ? day : '0' + day
      return fullYeamr + '' + month + '' + day
    }
    // $scope.reset()
    httpRequest
      .get_dictByTypeArr([
        'ivat_voucher_inv_type',
        'voucher_source',
        'voucher_account_status',
        'check_status',
        'voucher_invoice_sources',
      ])
      .then((res) => {
        $scope.dicData = res.data.value
      })

    //排序
    $scope.orderMap = initSortService('invoiceGatherParam')
    $scope.selectedHandle = function () {
      $scope.queryParam.orderMap = {}
      if ($scope.orderMap.sortKey) {
        $scope.queryParam.orderMap[$scope.orderMap.sortKey] =
          $scope.orderMap.sortVal
      }
      sessionStorage.setItem(
        'invoiceGatherParam',
        JSON.stringify($scope.queryParam)
      )
      $scope.queryList()
    }
    $scope.importHandle = function () {
      if ($scope.isCurrentPeriod) {
        logger.logTips('不可操作，只可在凭证号比对模式下使用', 'warn')
      }
    }
    // 导入
    $scope.uploadFiles = function uploadFiles(file, errFiles) {
      if (file == null && errFiles.length >= 1) {
        logger.logError(
          '文件类型错误，文件大小不超过5MB，只支持.xlsx,.xls格式文件导入'
        )
        return
      }
      if (file) {
        const data = {
          importFile: file,
          typeCode: 'IVAT_VOUCHER_INVOICE_LINK',
          taxPeriod: $scope.currentTaxPeriod,
        }
        file.upload = Upload.upload({
          url: `${host.etcloudIvatApp}dl/dlTaskService/importVoucher`,
          data,
        })
        // 文件上传
        // loading动画
        const importinglayer = layer.msg('玩命上传中，请耐心等待', {
          time: 0,
          skin: 'layer-loading-self',
          icon: 16,
          shade: 0.5,
        })
        file.upload.then(
          (response) => {
            $timeout(() => {
              if (!response.data.success) {
                // 关闭loading
                layer.close(importinglayer)
                return logger.logError(response.data.message || '上传失败')
              }
              file.result = response.data
              const { batchNo } = file.result.value
              const { sourceCount } = file.result.value
              const { errorCount } = file.result.value
              const { successKeyCount } = file.result.value
              const { reamrk } = file.result.value
              const _req = {
                pageNum: 1,
                pageSize: 10,
                param: batchNo,
              }
              $scope.queryList()
              // 请求错误信息
              httpRequest.post_getPageDlBatchInfoList(_req).then((res) => {
                // 关闭loading
                layer.close(importinglayer)
                // 获取导出信息详细数据
                const goodsImportRes = res.data.value
                const modalData = {
                  // 返回给弹窗的数据
                  idToken: $rootScope.idToken,
                  params: {
                    batchNo,
                    sourceCount,
                    successCount: sourceCount - errorCount,
                    errorCount,
                    data: goodsImportRes,
                    successKeyCount,
                    reamrk,
                  },
                  isOvatBill: false,
                  isOvatRedBill: false,
                  showRelieve: true,
                }
                // 弹窗实例
                const modalInstance = $uibModal.open({
                  templateUrl:
                    './app/outputManage/fillOpenManage/ovatBill/view/importOvatBillModalContentCtrl.html',
                  controller: 'importOvatBillModalContentCtrl',
                  backdrop: 'static',
                  openedClass: 'mod-modal-importexcel mod-modal mod-modal-lg',
                  windowClass: 'mod-modal mod-modal-lg',
                  bindToController: true,
                  resolve: {
                    items1() {
                      return modalData
                    },
                  },
                })
              })
            })
          },
          (response) => {
            if (response.status > 0) {
              // 关闭loading
              layer.close(importinglayer)
              logger.logError('上传失败 ')
            }
          },
          (evt) => {
            file.progress = Math.min(
              100,
              parseInt((100.0 * evt.loaded) / evt.total)
            )
            console.log(file.progress)
          }
        )
      }
    }

    // 下载导入模板
    $scope.downFinancial = function () {
      if ($scope.voucherModel != 1) {
        logger.logTips('不可操作，只可在凭证号比对模式下使用', 'warn')
        return
      }
      window.open(
        `${
          host.etcloudIvatApp
        }voucher/ivatVoucherInvoice/exportInvoiceTemple?accessToken=${localStorage.getItem(
          'id_token'
        )}&taxPeriod=${$scope.taxPeriod.value.replace(/-/, '')}`
      )
    }
    $scope.exportInvoice = function exportInvoice() {
      const reqObj = $.extend({}, $scope.queryParam.param, {
        selectIds: $scope.selectedRows.map((x) => x.invoiceId),
      })
      for (let i in $scope.queryParam.orderMap) {
        reqObj.sortField = i + ':' + $scope.queryParam.orderMap[i]
      }
      let _url = `${
        host.etcloudIvatApp
      }voucher/ivatVoucherInvoice/exportVoucherInvoiceQuery?accessToken=${localStorage.getItem(
        'id_token'
      )}`
      utils.post_downLoad(reqObj, _url)
    }
    $scope.pullDownHandle = function () {
      if (!$scope.isCurrentPeriod) return
      $scope.isCollapsed = !$scope.isCollapsed
    }
    $scope.closeSelect = function () {
      $scope.isCollapsed = false
    }
    function fixNumber(v) {
      if (v === null || v === '' || v === undefined) return ''
      return v.toFixed(2)
    }
    $scope.$watch('selectedRows.length', () => {
      if (!$scope.selectedRows.length) {
        $scope.invoiceStatistical = $scope.copyInvoiceStatistical
        return
      }
      const { totalAmt, totalTaxamt } = getOvatAmtService($scope.selectedRows)
      let result = {
        totalTaxamt,
        totalAmt,
        invoiceNum: $scope.selectedRows.length,
      }
      $scope.invoiceStatistical = result
    })
    function init() {
      getModalData()
      getPeriod()
    }
    init()
  }
}

invoiceGatherListCtrl.$inject = [
  '$scope',
  'sweetalert',
  '$state',
  'httpRequest',
  'logger',
  '$uibModal',
  '$timeout',
  'initSortService',
  'Upload',
  '$rootScope',
  'getOvatAmtService',
]

export default invoiceGatherListCtrl



// WEBPACK FOOTER //
// ./src/app/input/financialCounting/invoiceGather/invoiceGatherListCtrl.js